const ENV = {
	'dev.new.scp.spectral.energy': 'test',
	'test.scp.spectral.energy': 'test',
	'scp.spectral.energy': 'prod'
}[location.hostname]

export { ENV }
